module.exports = __webpack_public_path__ + "img/quxue-1.a88701e5.jpg";